import React from "react";
import { Modal, Button } from "antd";

interface CustomModalProps {
  title: string;
  okText: string;
  visible: boolean;
  closeModal: () => void;
  onOk?: () => void;
}

const CustomModal: React.FC<CustomModalProps> = ({
  title,
  okText,
  visible,
  closeModal,
  onOk,
  children,
}) => {
  const handleClick = () => {
    if (onOk) {
      onOk();
    } else {
      closeModal();
    }
  };

  return (
    <Modal
      visible={visible}
      title={title}
      closable={true}
      onCancel={closeModal}
      onOk={handleClick}
      footer={[
        <Button key="save" type="primary" onClick={handleClick}>
          {okText}
        </Button>,
      ]}
    >
      {children}
    </Modal>
  );
};

export default CustomModal;
